<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-14 19:22:15
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-23 14:11:33
-->
<template>
  <div class="login">
    <div class="header">
      <div class="c-1200">
        <div class="logo">
          <!-- <img src="../assets/exam/login_logo.png" alt="" /> -->
          <span>职业技能等级考试系统</span>
        </div>
        <div class="port">考生端</div>
      </div>
    </div>
    <div class="login_main">
      <div class="c-1200">
        <div class="wel">
          <h3>
            <p>欢迎登录</p>
            <p>职业技能等级考试系统</p>
          </h3>
        </div>
        <div class="login-card">
          <div class="title">考生登录</div>
          <el-form :model="loginForm" status-icon>
            <el-form-item prop="code">
              <el-input
                v-model="loginForm.admissionTicketId"
                placeholder="请输入准考证号码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="idCard">
              <el-input
                v-model="loginForm.idCard"
                placeholder="请输入身份证号码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login" @keyup.enter="keyDown(e)"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="copyright">copyright©2022湖北长江互联网教育研究院出品</div>
  </div>
</template>
<script>
import { login } from "@/api/exam";
import { setCookie } from "@/utils/cookies";
import to from "await-to";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        admissionTicketId: "",
        idCard: "",
      },
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
  methods: {
    async login() {
      const [res, err] = await to(login(this.loginForm));
      if (err) return this.$message.warning(err.msg);
      setCookie("myToken", res.data.token);
      setCookie("userInfo", res.data);
      this.$router.push("/");
    },
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13) {
        this.login(); // 定义的登录方法
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  height: 100vh;
  .header {
    width: 100%;
    height: 70px;
    background: #ffffff;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        span {
          display: block;
          height: 24px;
          line-height: 22px;
          position: relative;
          font-size: 18px;
          font-weight: 500;
          color: #3671bf;
          // border-left: 1px solid #c1c8d1;
          padding-left: 12px;
        }
      }
      .port {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .login_main {
    height: calc(100% - 70px);
    background: url("../assets/exam/login_bg.png") center;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .wel {
      display: flex;
      flex-direction: column;
      h3 {
        font-size: 54px;
        font-weight: bold;
        color: #ffffff;
        line-height: 80px;
        margin-bottom: 117px;
      }
    }
    .login-card {
      float: right;
      text-align: center;
      box-sizing: border-box;
      width: 400px;
      height: 410px;
      background: #ffffff;
      border-radius: 8px;
      padding-top: 50px;
      .title {
        font-size: 24px;
        line-height: 24px;
        font-weight: 500;
        color: #292c33;
        margin-bottom: 50px;
      }
      .el-form-item {
        margin-bottom: 30px;
      }
      ::v-deep .el-input {
        width: 320px;
        height: 40px;
        background: #ffffff;
        border-radius: 4px;
      }
      ::v-deep .el-button {
        box-sizing: border-box;
        margin-top: 20px;
        width: 320px;
        height: 40px;
        background: #3882e4;
        box-shadow: 0px 4px 10px 1px #b6c5db;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        // line-height: 40px;
      }
    }
  }
  .copyright {
    position: absolute;
    bottom: 30px;
    text-align: center;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    line-height: 14px;
  }
}
</style>
